// Centralized brand constants
// Update these values to change branding across the entire app

export const BRAND = {
  name: "Commons",
  tagline: "Less reporting, more designing.",
  description:
    "Async standups, crits, retros, and AI rollups — so your team stays aligned without the overhead.",
  url: "https://trycommons.com",
  email: "noreply@trycommons.com",
} as const;
